// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2t4yi","rightAdornment":"Header_rightAdornment__UQV4K"};